export class AndroidDeviceModel {
  Code: string;
  LocationName: string;
  CategoryId: number;
}
